import { render, staticRenderFns } from "./index.vue?vue&type=template&id=602a7420&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/avatorUploader.css?vue&type=style&index=0&id=602a7420&scoped=true&lang=css&"
import style1 from "./style/index.css?vue&type=style&index=1&id=602a7420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602a7420",
  null
  
)

export default component.exports